import React from "react"
import { connect } from "react-redux"
import { campaignPopupSortPerformanceList, updateCampaignPopupTablePage } from "../../campaignPopupActions"
import Table from "../../../common/components/table/table"
import CampaignsTableConsts from "../../../campaignsV2/campaignsTableConsts"
import Pagination from "../../../common/components/pagination"
import { getColumnsForTab } from "../../CampaignPopupColumns"

class CampaignPopupPerformanceByBrowserList extends React.Component {
  constructor(props) {
    super(props)

    this.tableName = "performanceByBrowser"
    this.columns = getColumnsForTab(
      this.props.campaign.provider_id,
      this.props.campaign.post_style,
      CampaignsTableConsts.browser.fieldName
    )
  }

  sortBrowsersBy = (column) => {
    this.props.dispatch(campaignPopupSortPerformanceList(column, this.tableName))
  }

  getHeader = () => {
    const cells = Object.values(this.columns).map((column) => ({
      fieldName: column.fieldName,
      value: column.title,
      clickable: true,
      cellSize: column.cellSize,
    }))

    return {
      cells,
    }
  }

  getRow = (browser) => {
    const cells = Object.values(this.columns).map((column) => ({
      fieldName: column.fieldName,
      cssClasses: column.cssClasses || [],
      value: column.defaultFormat(browser[column.fieldName]),
      cellSize: column.cellSize,
    }))

    return { cells }
  }

  getSummaryRow = (summaryData) => {
    const cells = Object.values(this.columns).map((column) => ({
      fieldName: column.fieldName,
      value: column.defaultFormat(summaryData[column.fieldName]),
      value:
        column.fieldName === CampaignsTableConsts.browser.fieldName
          ? "Total"
          : column.defaultFormat(summaryData[column.fieldName]),
    }))

    return { cssClasses: ["summary-row"], allowRowSelection: false, cells }
  }

  render() {
    const header = this.getHeader()
    let rows = []
    const { performanceByBrowser, summaryRow, currentPage, itemsPerPage } = this.props

    // Add summary row if data is available
    if (performanceByBrowser.length > 0) {
      rows.push(this.getSummaryRow(summaryRow))
    }

    // Add data rows with pagination
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = Math.min(currentPage * itemsPerPage, performanceByBrowser.length)

    for (let i = startIndex; i < endIndex; i++) {
      rows.push(this.getRow(performanceByBrowser[i]))
    }

    // Add pagination if necessary
    const pagination =
      performanceByBrowser.length > itemsPerPage ? (
        <Pagination
          itemsArr={performanceByBrowser.length}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          updatePage={(updatedPage) => {
            this.props.dispatch(updateCampaignPopupTablePage(updatedPage, this.tableName))
          }}
        />
      ) : null

    return (
      <div>
        <Table
          header={header}
          rows={rows}
          sort={{
            sortBy: this.props.sortBy,
            sortDirection: this.props.sortDirection,
            sortHandler: this.sortBrowsersBy,
          }}
          scrolling={{
            containerClass: ".campaign-popup-container",
            includeNavigationBar: false,
          }}
          cssClasses={["campaign-popup-list"]}
          isLoadingData={performanceByBrowser.length === 0}
        />
        {pagination}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    sortBy: state.campaignPopupV2.performanceByBrowser.sortBy,
    sortDirection: state.campaignPopupV2.performanceByBrowser.sortDirection,
    performanceByBrowser: state.campaignPopupV2.performanceByBrowser.dataForTable,
    summaryRow: state.campaignPopupV2.performanceByBrowser.summaryRow,
    itemsPerPage: state.campaignPopupV2.performanceByBrowser.itemsPerPage,
    currentPage: state.campaignPopupV2.performanceByBrowser.currentPage,
    campaign: state.campaignPopupV2.campaign,
  }
}

export default connect(mapStateToProps)(CampaignPopupPerformanceByBrowserList)
